import React, { useCallback, useState } from 'react';

import { Button, Card, CardContent, CardHeader, Stack, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

import { type UpgradePricingFilters, parseDateInput } from './CharterUpgradePricingHelpers';

type Props = {
  isLoading: boolean;
  onSearch: (filters: UpgradePricingFilters) => void;
  onClear: () => void;
};

export default function CharterUpgradePricingFilters({ isLoading, onSearch, onClear }: Props) {
  const [depAirport, setDepAirport] = useState<string | undefined>(undefined);
  const [arrAirport, setArrAirport] = useState<string | undefined>(undefined);
  const [dateFrom, setDateFrom] = useState<string | undefined>(undefined);
  const [dateTo, setDateTo] = useState<string | undefined>(undefined);

  const handleSearch = useCallback(() => {
    onSearch({
      departureDateFrom: dateFrom ? parseDateInput(dateFrom) : undefined,
      departureDateTo: dateTo ? parseDateInput(dateTo) : undefined,
      depAirport,
      arrAirport,
    });
  }, [dateFrom, dateTo, depAirport, arrAirport, onSearch]);

  const handleClear = useCallback(() => {
    setDepAirport(undefined);
    setArrAirport(undefined);
    setDateFrom(undefined);
    setDateTo(undefined);
    onClear();
  }, [onClear]);

  return (
    <Card>
      <CardHeader title="Filters" sx={{ pb: 0 }} />

      <CardContent>
        <Stack spacing={3}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth
                size="small"
                label="Departure airport"
                placeholder="MEL"
                value={depAirport ?? ''}
                onChange={(e) => setDepAirport(e.target.value.toUpperCase() || undefined)}
                inputProps={{ maxLength: 3 }}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth
                size="small"
                label="Arrival airport"
                placeholder="MLE"
                value={arrAirport ?? ''}
                onChange={(e) => setArrAirport(e.target.value.toUpperCase() || undefined)}
                inputProps={{ maxLength: 3 }}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth
                size="small"
                label="Departure date from"
                placeholder="DD/MM/YYYY"
                value={dateFrom ?? ''}
                onChange={(e) => setDateFrom(e.target.value || undefined)}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth
                size="small"
                label="Departure date to"
                placeholder="DD/MM/YYYY"
                value={dateTo ?? ''}
                onChange={(e) => setDateTo(e.target.value || undefined)}
              />
            </Grid>
          </Grid>

          <Stack direction="row" spacing={2} alignItems="center">
            <Button variant="contained" onClick={handleSearch} disabled={isLoading}>
              Search
            </Button>

            <Button variant="text" onClick={handleClear} disabled={isLoading}>
              Clear filters
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
